import React, { useEffect, useMemo, useState } from "react";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
} from "chart.js";
import { Line } from "react-chartjs-2";
import { History } from "./App";
import moment from "moment";
import axios from "axios";

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
);

export const Chart = () => {
	const [usdHistory, setUSDHistory] = useState<History[]>([]);
	const [eurHistory, setEURHistory] = useState<History[]>([]);
	const [plnHistory, setPLNHistory] = useState<History[]>([]);

	const options = useMemo(() => {
		return {
			responsive: true,
			maintainAspectRatio: false,
			plugins: {
				legend: {
					position: "top" as const
				},
				title: {
					display: true,
					text: "Currencies history"
				}
			},
			scales: {
				y: {
					ticks: {
						stepSize: 1
					},
                    beforeBuildTicks: function(axis: any) {
                        const diff = axis.max - axis.min
                        axis.options.ticks.stepSize = diff/10;
                    }
				}
			}
		};
	}, []);
	useEffect(() => {
		axios
			.get(
				`https://binance-p2p-api-zon6tf6nta-uc.a.run.app/api/history?from=USD&to=EGP`
			)
			.then(res => {
				setUSDHistory(res.data);
			});
	}, []);
	useEffect(() => {
		axios
			.get(
				`https://binance-p2p-api-zon6tf6nta-uc.a.run.app/api/history?from=EUR&to=EGP`
			)
			.then(res => {
				setEURHistory(res.data);
			});
	}, []);
	useEffect(() => {
		axios
			.get(
				`https://binance-p2p-api-zon6tf6nta-uc.a.run.app/api/history?from=PLN&to=EGP`
			)
			.then(res => {
				setPLNHistory(res.data);
			});
	}, []);

	const labels = usdHistory.map(h =>
		moment(Math.floor(h.timestamp / (1000* 60 * 5))*  (1000* 60 * 5)).format("HH:mm"));
	const data = {
		labels,
		datasets: [
			{
				label: `USD to EGP`,
				data: usdHistory.map(h => h.rate)
			},
			{
				label: `EUR to EGP`,
				data: eurHistory.map(h => h.rate)
			},
			{
				label: `PLN to EGP`,
				data: plnHistory.map(h => h.rate)
			}
		]
	};
	return (
		<div
				style={{
					display: "grid",
					alignItems: "center",
					justifyContent: "center",
					maxWidth: "600px",
					width: "100%",
					margin: "auto",
                    height: "400px"
				}}
			>
			<Line options={options} data={data}/>
		</div>
	);
};

export default Chart;
